import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ALL CLIENTS SERVICE
export const getClientsService = createAsyncThunk(
  "clients/getClientsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.clientURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE CLIENT SERVICE
export const createClientService = createAsyncThunk(
  "clients/createClientService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.clientURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE CLIENT SERVICE
export const deleteClientService = createAsyncThunk(
  "clients/deleteClientService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.clientURL}/${params?.id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE CLIENT SERVICE
export const updateClientService = createAsyncThunk(
  "clients/updateClientService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.clientURL}/${params?.id}`,
        params.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET CLIENT BY ID SERVICE
export const getClientByIdService = createAsyncThunk(
  "clients/getClientByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.clientURL}${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);


// Employee
// GET =>  All ALL Employess SERVICE
export const getEmployeeService = createAsyncThunk(
  "clients/getEmployeeService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.employeesURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE Employee SERVICE
export const createEmployeeService = createAsyncThunk(
  "clients/createEmployeeService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.employeesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE Employee SERVICE
export const deleteEmployeeService = createAsyncThunk(
  "clients/deleteEmployeeService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.employeesURL}/${params?.id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE Employee SERVICE
export const updateEmployeeService = createAsyncThunk(
  "clients/updateEmployeeService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.employeesURL}/${params?.id}`,
        params.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE CLIENT SERVICE
export const updateClientPasswordService = createAsyncThunk(
  "clients/updateClientPasswordService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.clientURL}/${params?.id}/reset-password`,
        {password:params?.password}
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET CLIENT BY ID SERVICE
export const getEmployeeByIdService = createAsyncThunk(
  "clients/getEmployeeByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.employeesURL}${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);